exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image-code {\n  position: relative;\n}\n.image-code .image-code__code {\n  position: absolute;\n  right: 0.2rem;\n  top: 0.1rem;\n  height: 0.6rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/component/ImageCode/ImageCode.less
// module id = 592
// module chunks = 0